import { isArray, isObject, mapValues } from 'lodash';

export const deepReplaceNullsWithUndefined = <T>(value: T): T => {
  if (isArray(value)) {
    return value.map(deepReplaceNullsWithUndefined) as T;
  } else if (isObject(value)) {
    return mapValues(value, deepReplaceNullsWithUndefined) as T;
  } else if (value === null) {
    return undefined as T;
  }
  return value;
};
